import { compose, both, either, not, propEq, propSatisfies } from 'ramda';

import { isWaybetterProduct } from '../utils';

const isNotWaybetterProduct = compose(not, isWaybetterProduct);

const isWbProductMember = both(
  propSatisfies(isWaybetterProduct, 'product'),
  propEq('isActiveWbMember', true)
);

const isOpProductMember = both(
  propSatisfies(isNotWaybetterProduct, 'product'),
  propEq('isActiveOpMember', true)
);

export const isProductMember = either(isWbProductMember, isOpProductMember);
